import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import {Button} from "@material-ui/core"
import { CONFIRMATION_MODAL_KEY, clearActiveModal, getActiveModal, getModalParams } from '../v2_actions/ui'
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
    buttons: {
        display: "flex",
        justifyContent: "center",
        padding: "10px 20px 20px",
    },
    title: {
        background: "#214986",
        color: "#ffffff",
        fontSize: 14,
        fontWeight: 600,
        padding: "12px 20px",
    },
    body: {
        padding: "20px",
        fontSize: 13,
        lineHeight: 1.6,
    },
    inputField: {
        width: "100%",
        padding: "8px 10px",
        fontSize: 13,
        border: "1px solid #ccc",
        borderRadius: 4,
        marginTop: 10,
        boxSizing: "border-box",
    },
    confirmButton: {
        background: "#214986",
        color: "#ffffff",
        fontWeight: 600,
        "&:hover": {
            background: "#1a3a6b",
        },
    },
    cancelButton: {
        marginRight: 10,
    },
})

export const ConfirmationModal = () => {
    const dispatch = useDispatch()
    const classes = useStyles()
    const is_active = useSelector((state) => getActiveModal(state) === CONFIRMATION_MODAL_KEY)
    const { text, title, onConfirmed, can_cancel, inputField } = useSelector((state) => getModalParams(state))
    const [inputValue, setInputValue] = useState("")

    useEffect(() => {
        if (inputField) {
            setInputValue(inputField.defaultValue || "")
        }
    }, [inputField])

    const onClose = () => {
        if ( is_active ) {
            dispatch(clearActiveModal())
        }
    }

    const onConfirm = () => {
        if (inputField) {
            onConfirmed(inputValue)
        } else {
            onConfirmed()
        }
        onClose()
    }

    if ( ! is_active ) {
        return null
    }

    return (

        <Dialog open={true}
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
        >
          <MuiDialogTitle className={classes.title}>
            {title || "Confirm"}
          </MuiDialogTitle>
          <div className={classes.body}>
            {text}
            {inputField &&
              <input
                className={classes.inputField}
                type="text"
                placeholder={inputField.placeholder || ""}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            }
          </div>
          <div className={classes.buttons}>
            { can_cancel !== false &&
              <Button className={classes.cancelButton} variant="outlined" onClick={onClose}>
                Cancel
              </Button>
            }
            <Button className={classes.confirmButton} variant="contained" onClick={onConfirm}>
              OK
            </Button>
          </div>
        </Dialog>

    )
}
